module.exports = __webpack_public_path__ + "img/education_red_dot.8db9277f.svg";